import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ConfigConstants, NotificationModel } from '@evorait/pace-core';
import { faArrowDown, faArrowUp, faExchangeAlt, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'pace-notification-list',
    templateUrl: './notification-list.component.html',
    styleUrls: ['./notification-list.component.scss'],
    standalone: false,
})
export class NotificationListComponent implements OnInit, OnChanges {
    @Input()
    public model: NotificationModel[];

    @Input()
    public title: string;

    public notificationList: NotificationModel[];
    public borderClass = '';
    public effectCodeIcon: IconDefinition;
    public effectCodeIconColorClass: 'red' | 'orange' | 'green';
    public faArrowDown = faArrowDown;
    public faExchangeAlt = faExchangeAlt;
    public faArrowUp = faArrowUp;

    public strings: {
        noNotificationsError: string;
    };
    public constructor(private readonly translate: TranslateService) {}

    public ngOnInit(): void {
        this.strings = {
            noNotificationsError: <string>this.translate.instant('DASHBOARD_NO_RESULTS_LABEL'),
        };
    }

    public ngOnChanges(changesObj: SimpleChanges): void {
        if (changesObj.model && changesObj.model.currentValue) {
            this.notificationList = <NotificationModel[]>changesObj.model.currentValue;
        }
    }

    public getBorderClass(effectCode: number): string {
        if (
            effectCode.toString() === ConfigConstants.EQUIPMENT_STATUS.TOTALLY_DOWN ||
            effectCode.toString() === ConfigConstants.EQUIPMENT_STATUS.APP_DOWN
        ) {
            this.borderClass = 'border-red';
            this.effectCodeIcon = faArrowDown;
            this.effectCodeIconColorClass = 'red';
        } else if (
            effectCode.toString() === ConfigConstants.EQUIPMENT_STATUS.PARTIALLY_DOWN ||
            effectCode.toString() === ConfigConstants.EQUIPMENT_STATUS.APP_PARTIALLY_DOWN ||
            effectCode.toString() === ConfigConstants.EQUIPMENT_STATUS.PARTIALLY_DOWN_CRITICAL
        ) {
            this.borderClass = 'border-orange';
            this.effectCodeIcon = faExchangeAlt;
            this.effectCodeIconColorClass = 'orange';
        } else if (
            effectCode.toString() === ConfigConstants.EQUIPMENT_STATUS.WORKING ||
            effectCode.toString() === ConfigConstants.EQUIPMENT_STATUS.APP_WORKING ||
            effectCode.toString() === ConfigConstants.EQUIPMENT_STATUS.PARTIALLY_DOWN_NORMAL
        ) {
            this.borderClass = 'border-green';
            this.effectCodeIcon = faArrowUp;
            this.effectCodeIconColorClass = 'green';
        }
        return this.borderClass;
    }
}
